function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9288 20.243L20.2118 17.381C19.4188 16.06 18.9998 14.547 18.9998 13.007V10.5C18.9998 7.335 16.8878 4.65802 13.9998 3.795V2.00002C13.9998 0.897 13.1028 0 11.9998 0C10.8967 0 9.99975 0.897 9.99975 2.00002V3.795C7.11178 4.65802 4.99978 7.335 4.99978 10.5V13.007C4.99978 14.547 4.58076 16.059 3.78876 17.38L2.07178 20.242C1.97878 20.397 1.97676 20.589 2.06578 20.746C2.15479 20.903 2.31979 21 2.49979 21H21.4998C21.6798 21 21.8458 20.9031 21.9348 20.7471C22.0238 20.591 22.0208 20.397 21.9288 20.243Z",
  fill: "#29394D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.85083 22C9.41483 23.178 10.6088 24 11.9998 24C13.3908 24 14.5848 23.178 15.1488 22H8.85083Z",
  fill: "#29394D"
});

var SvgNotifs = function SvgNotifs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotifs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifs.a3d222c3.svg";
export { ForwardRef as ReactComponent };